import { Client } from "@microsoft/microsoft-graph-client/lib/src/browser";

export const getAuthenticatedClient = (accessToken: string) => {
    return Client.init({
        authProvider: (done: any) => {
            done(null, accessToken);
        }
    });
}